<template>
<div class="list-schedule" :class="{'compacted':compacted && !viewAll}">
	<table class="table animated fadeIn faster" v-if="days">
        <tr class="head">
            <td>
				<div class="btn btn-light" @click="prevDay()" :class="{'disabled':currentDate==today}"><i class="icon-left-open-1"></i></div>
			</td>
            <td v-for="day in days" :key="day.id">{{day.date | moment('dd') }} <br><small>{{day.date | moment('DD-MM') }}</small></td>
			<td>
				<div class="btn btn-light" @click="nextDay()"><i class="icon-right-open-1"></i></div>
			</td>
        </tr>
		<tr v-if="days && !loading">
            <td></td>
			<td v-for="day in days" :key="day.id">
				<div class="btn btn-sm btn-success" v-for="hour in day.hours" :key="hour" @click="selectHour(hour)">{{hour}}</div>
			</td>
            <td></td>
        </tr>
    </table>
	<div class="loading animated fadeIn faster" v-if="loading" >
		<i class="icon-spin6 animate-spin"></i>
	</div>
	
	<div class="show-more" v-if="compacted && !viewAll" @click="viewAll=true">
		Ver mas disponibilidad
	</div>
	<div class="show-more" v-if="compacted && viewAll" @click="viewAll=false">
		Ver menos disponibilidad
	</div>
</div>
</template>

<script>
export default {
	name: 'ListSchedule',
	props:{
		cantDays: {
			type: Number,
			default:5
		},
		compacted: {
			type: Boolean,
			default: false
		},
		startDate: {
			type: Date,
			default: ()=>{return new Date();}
		},
	},
	data(){
		return {
			loading:false,
			viewAll:false,
			days:[],
			currentDate: this.$moment(this.startDate,'DD-MM-YYYY'),
			today: this.$moment(new Date(),'DD-MM-YYYY')
		}
	},
	mounted(){
		this.initDates();
	},
	methods:{
		initDates(){		
			var i=1;
			let newDay = {};
			newDay.date = this.$moment(this.currentDate, "DD-MM-YYYY");
			newDay.hours = [];
			this.days.push(newDay);
			for(i; i < this.cantDays; i++){
				let newDay = {};
				newDay.date = this.$moment(this.currentDate, "DD-MM-YYYY").add(i, 'days');
				newDay.hours = [];
				this.days.push(newDay);
			}
			this.loadDates();
		},
		loadDates(){
			this.loading = true;
			let hours = [
				['09:00','09:15','14:30','15:00','16:15','16:30','17:15','17:45','18:15'],
				['09:15','11:45','16:15','16:30','17:15','18:15'],
				['08:45','09:15','11:45','14:30','15:00','17:30','17:45','18:15'],
				['11:45','14:30','16:30','17:15'],
			]
			this.days.forEach( (day)=>{
				day.hours = hours[Math.floor((Math.random() * 3) + 1)]
			});

			setTimeout(()=>{ 
				this.loading = false;
			}, 1000);

		},
		nextDay(){
			console.log('load Dates',this.currentDate);
			this.days = [];
			this.currentDate = this.$moment(this.currentDate, "DD-MM-YYYY").add(1, 'days');
			this.initDates();
		},
		prevDay(){
			console.log('load Dates',this.today,this.currentDate);
			let prevDay = this.$moment(this.currentDate, "DD-MM-YYYY").add(-1, 'days');
			if( this.today <= prevDay ){
				this.days = [];
				this.currentDate = prevDay;
				this.initDates();
			}
		},
		selectHour(){

		}
	}
}
</script>

<style scoped>
.loading{
	width: 100%;
	padding: 50px;
	text-align: center;
	font-size: 22px;
	color: #e74e84;
}
.list-schedule{
	overflow: hidden;	
	position: relative;
	padding: 0px;

}
.list-schedule.compacted{
	max-height: 180px;
}
.list-schedule table{
	width: 100%;
}

/* .list-schedule table tr.head {
    background-color: #25254c;
    color: #fff;
} */
.list-schedule table tr{
	text-align: center;
}
.list-schedule table tr.head td{
	border-top: none;
	line-height: 13px;
	text-transform: uppercase;
}
.list-schedule table tr.head td .btn{
	width: 24px;
	padding: 0.375rem 0rem;
}
.list-schedule table tr td{
    padding: 5px;
    max-width: 70px;
}
.list-schedule table tr td:first-child,.list-schedule table tr td:last-child{
    padding: 0px;
    width: 30px;
}
.list-schedule table tr td .btn{
    display: block;
	margin: 2px;
	cursor: pointer;
	font-size: 0.75rem;
	line-height: 1.5;
	padding: 2px;
}

.show-more{
	position: absolute;
	bottom: 0px;
	width:100%;
	text-align: center;
	left: 0px;
	padding-top:12px; 
	font-size: 12px;
	font-weight: 500;
	cursor: pointer;
	background: rgba(255,255,255,0);
	background: -moz-linear-gradient(top, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 74%, rgba(255,255,255,1) 100%);
	background: -webkit-gradient(left top, left bottom, color-stop(0%, rgba(255,255,255,0)), color-stop(74%, rgba(255,255,255,1)), color-stop(100%, rgba(255,255,255,1)));
	background: -webkit-linear-gradient(top, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 74%, rgba(255,255,255,1) 100%);
	background: -o-linear-gradient(top, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 74%, rgba(255,255,255,1) 100%);
	background: -ms-linear-gradient(top, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 74%, rgba(255,255,255,1) 100%);
	background: linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 74%, rgba(255,255,255,1) 100%);
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#ffffff', GradientType=0 );
	}
</style>
